module.exports = __webpack_public_path__ + "static/img/companybg.350cd85.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/companybg.png
// module id = eb8+
// module chunks = 1